import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

/**
 * Fila de tabs/chips con scroll horizontal que NO ensancha el layout.
 * El contenedor queda acotado al ancho del padre; el contenido `w-max` scrollea dentro.
 * Evita el recorte por overflow-x-hidden del AdminLayout en móvil.
 */
export function ScrollChipRow({
    children,
    className,
    innerClassName,
}: {
    children: ReactNode;
    className?: string;
    innerClassName?: string;
}) {
    return (
        <div
            className={cn(
                'min-w-0 max-w-full overflow-x-auto overscroll-x-contain scrollbar-thin touch-pan-x',
                className,
            )}
        >
            <div className={cn('flex w-max items-center gap-1.5', innerClassName)}>
                {children}
            </div>
        </div>
    );
}
